// AUTO-GENERATED GraphQL Builder for LinkedAccountView
import * as Builders from '../';
export class LinkedAccountViewBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  id(){ return this.add('id'); }
  vendorId(){ return this.add('vendorId'); }
  linkedAccountRef(){ return this.add('linkedAccountRef'); }
  status(){ return this.add('status'); }
  setupStep(){ return this.add('setupStep'); }
  accountEmail(){ return this.add('accountEmail'); }
  productRef(){ return this.add('productRef'); }
  requirements(){ return this.add('requirements'); }
  failureReason(){ return this.add('failureReason'); }
  bankName(){ return this.add('bankName'); }
  accountNumberMasked(){ return this.add('accountNumberMasked'); }
  beneficiaryName(){ return this.add('beneficiaryName'); }
  activatedDate(){ return this.add('activatedDate'); }
  lastSyncedDate(){ return this.add('lastSyncedDate'); }
  createdDate(){ return this.add('createdDate'); }
  createdByName(){ return this.add('createdByName'); }
}
